export enum StickerType {
    NO_PRINT = 0,
    PER_UNIT = 1,
    PER_SET = 2,
}
